<template>
  <v-alert
    v-if="correoFaltante || telefonoFaltante"
    type="warning"
    dense
    outlined
    icon="mdi-alert-circle"
  >
    Este personal tiene datos de contacto pendientes de completar: <strong>{{ mensajeCampos }}</strong
    >. Algunas operaciones podrían fallar hasta que se actualicen.
  </v-alert>
</template>

<script>
export default {
  name: 'DatosFaltantesBanner',
  props: {
    correoFaltante: {
      type: Boolean,
      default: false,
    },
    telefonoFaltante: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mensajeCampos() {
      const campos = []
      if (this.correoFaltante) campos.push('correo electrónico')
      if (this.telefonoFaltante) campos.push('teléfono')
      if (campos.length === 2) return `${campos[0]} y ${campos[1]}`
      return campos.join('')
    },
  },
}
</script>
